import React from "react";
import styles from "./activities/Activities.module.scss";
import {detectDir} from "../../../../../../util/util";

const Activities = ({ title }) => {

  return (
    <span style={{textAlign:detectDir(title,true)}} className={styles.Activities}>
      <span>{ title }</span>
    </span>
  )
};

export default Activities;